var FormRefund = ( function($) {

    var FormRefund = function(options) {
        var that = this;

        // DOM
        that.$wrapper = options["$wrapper"];
        
        // Want return block
        that.return_type = {
            svc: 'svc',
            ticket: 'ticket',
        }

        that.return_type_custom_fields = {
            svc: '1784',
            ticket: '1769'
        }

        that.select_toggle_return_type = '.js-toggle-return-type'
        that.$toggle_return_type = that.$wrapper.find(that.select_toggle_return_type)

        that.$el_return_type_custom_fields = that.$wrapper.find('.js-form-refund-custom-fields')

        that.$el_return_type_svc = that.$wrapper.find('.js-return-type-svc')
        that.$el_return_type_ticket = that.$wrapper.find('.js-return-type-ticket')
        that.$el_return_type_header = that.$wrapper.find('.js-return-type-header')
        that.$el_return_type_footer = that.$wrapper.find('.js-return-type-footer')

        that.$el_return_type_insurance = that.$wrapper.find('.js-return-type-insurance')

        // Payment type block
        that.payment_type = {
            card: 'card',
            sbp: 'sbp',
            invoiceBox: 'invoice-box',
            other: 'other'
        }

        that.select_toggle_payment_type = '.js-toggle-payment-type'
        that.$toggle_payment_type = that.$wrapper.find(that.select_toggle_payment_type)

        that.$el_payment_type_card = that.$wrapper.find('.js-toggle-payment-type-card')
        that.$el_payment_type_sbp = that.$wrapper.find('.js-toggle-payment-type-sbp')
        that.$el_payment_type_invoice_box = that.$wrapper.find('.js-toggle-payment-type-invoice-box')
        that.$el_payment_type_other = that.$wrapper.find('.js-toggle-payment-type-other')

        // Return reason block
        that.return_reason = {
            voluntary: 'voluntary',
            involuntary: 'involuntary',
            null: 'null'
        }

        that.select_toggle_return_reason = '.js-toggle-return-reason'
        that.$toggle_return_reason = that.$wrapper.find(that.select_toggle_return_reason)

        that.$el_return_reason_voluntary = that.$wrapper.find('.js-toggle-return-reason-voluntary')
        that.$el_return_reason_involuntary = that.$wrapper.find('.js-toggle-return-reason-involuntary')
        that.$el_return_reason_null = that.$wrapper.find('.js-toggle-return-reason-null')

        // Return reason advanced block
        that.return_reason_advanced = {
            illness: 'passenger-illness',
            death_family: 'passenger-death-family'
        }

        that.select_return_reason_advanced = '.js-return-reason-advanced'
        that.select_toggle_return_reason_advanced = '.js-toggle-return-reason-advanced'
        that.$return_reason_advanced = that.$wrapper.find(that.select_return_reason_advanced)
        that.$toggle_return_reason_advanced = that.$wrapper.find(that.select_toggle_return_reason_advanced)

        that.$el_return_reason_advanced_illness = that.$wrapper.find('.js-toggle-return-reason-advanced-illness')
        
        // Return service block
        that.select_refund_svcs = '.js-refund-svcs'
        that.select_refund_svcs_index = '.js-refund-svcs-index'
        that.select_refund_svcs_remove_button = '.js-refund-svcs-remove-button'
        that.select_refund_svcs_add_button = '.js-refund-svcs-add-button'

        that.select_refund_svcs_svc = '.js-refund-svcs-svc'
        that.select_refund_svcs_emd = '.js-refund-svcs-emd'

        that.$el_refund_svcs = that.$wrapper.find(that.select_refund_svcs)

        that.$copied_refund_svcs_template = that.$el_refund_svcs.clone()
        
        // Return ticket block
        that.select_refund_ticket = '.js-refund-ticket'
        that.select_refund_ticket_index = '.js-refund-ticket-index'
        that.select_refund_ticket_remove_button = '.js-refund-ticket-remove-button'
        that.select_refund_ticket_add_button = '.js-refund-ticket-add-button'
        
        that.select_refund_ticket_number = '.js-refund-ticket-number'
        that.select_refund_ticket_fio = '.js-refund-ticket-fio'

        that.$el_refund_ticket = that.$wrapper.find(that.select_refund_ticket)

        that.$copied_refund_ticket_template = that.$el_refund_ticket.clone()

        // DYNAMIC VARS
        that.locales = options['locales'] || {};

        // INIT
        that.init(options);
    };

    var Self = FormRefund;
    Self.className = 'FormRefund';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            var unique_id = response?.data?.unique_id

            that.$wrapper.find('.js-form-refund').hide()
            that.$wrapper.find('.js-success-result').show()
            that.$wrapper.find('.js-unique-id').text(unique_id)
            $.sa.scrollToNode(that.$wrapper, 200, null);
        }

        options.onAlertSubmitCallback = function (error) {
            var msg = error && error.message ? error.message : that.locales.error_message;
            $.uiModal({
                header_icons: '<div class="align-center"><i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-circle-x"></i></div>',
                header_title: '<div class="align-center">' + that.locales.error_title + '</div>',
                content: '<div class="align-center">' + msg + '</div>',
                button_align_center: true,
                button_confirm_text: that.locales.confirm_text,
            });
        }

        Parent.prototype.init.call(that, options);

        that.initToggles()
        that.initGroups()

        that.initInputMask()
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form-refund',
            previous_action: '', //TODO: set this when other password restoration methods would be done
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initInputMask = function () {
        var that = this;

        UIInputMask.prototype.initBookingNumber(that.$wrapper)
        UIInputMask.prototype.initINN(that.$wrapper)
        UIInputMask.prototype.initBIK(that.$wrapper)
        UIInputMask.prototype.initAccountNumber(that.$wrapper)
        UIInputMask.prototype.initCardLastNumbers(that.$wrapper)
        UIInputMask.prototype.initPhoneMask(that.$wrapper)
        UIInputMask.prototype.initEmailValidate(that.$wrapper)
        UIInputMask.prototype.initDateMask(that.$wrapper);
    }

    Self.prototype.initToggles = function () {
        var that = this;
        that.initWantReturnToggle()
        that.initPaymentTypeToggle()
        that.initReturnReasonToggle()
        that.initReturnReasonAdvancedToggle()
    }

    Self.prototype.initWantReturnToggle = function () {
        var that = this;
        $.sa.$document.on('change', that.select_toggle_return_type, function (e) {
            var $toggle_select = $(e.target)

            if ($toggle_select.hasClass(that.select_toggle_return_type.substring(1))) {
                var selected_type = $toggle_select.val()
                
                that.$el_return_type_header.show()
                that.$el_return_type_footer.show()

                that.$el_return_type_svc.hide()
                that.$el_return_type_ticket.hide()
                that.$el_return_type_insurance.hide()
    
                if (selected_type === that.return_type.svc) {
                    that.$el_return_type_svc.show()
                    that.$el_return_type_custom_fields.val(that.return_type_custom_fields.svc)
                } else if (selected_type === that.return_type.ticket) {
                    that.$el_return_type_ticket.show()
                    that.$el_return_type_insurance.show()
                    that.$el_return_type_custom_fields.val(that.return_type_custom_fields.ticket)
                }
            }

        });
    }

    Self.prototype.initPaymentTypeToggle = function () {
        var that = this;
        $.sa.$document.on('change', that.select_toggle_payment_type, function (e) {
            var $toggle_select = $(e.target)

            if ($toggle_select.hasClass(that.select_toggle_payment_type.substring(1))) {
                var selected_type = $toggle_select.val()
                
                that.$el_payment_type_card.hide()
                that.$el_payment_type_sbp.hide()
                that.$el_payment_type_invoice_box.hide()
                that.$el_payment_type_other.hide()
    
                if (selected_type === that.payment_type.card) {
                    that.$el_payment_type_card.show()
                } else if (selected_type === that.payment_type.sbp) {
                    that.$el_payment_type_sbp.show()
                } else if (selected_type === that.payment_type.invoiceBox) {
                    that.$el_payment_type_invoice_box.show()
                } else if (selected_type === that.payment_type.other) {
                    that.$el_payment_type_other.show()
                }
            }
        });
    }

    Self.prototype.initReturnReasonToggle = function () {
        var that = this;

        $.sa.$document.on('change', that.select_toggle_return_reason, function (e) {
            var $toggle_select = $(e.target)

            if ($toggle_select.hasClass(that.select_toggle_return_reason.substring(1))) {
                var selected_type = $toggle_select.val()
                
                that.$el_return_reason_voluntary.hide()
                that.$el_return_reason_involuntary.hide()
                that.$el_return_reason_null.hide()

                // скрытие следующего блока
                UISelect.prototype.__clearValue(that.$return_reason_advanced)
                that.$el_return_reason_advanced_illness.hide()
    
                if (selected_type === that.return_reason.voluntary) {
                    that.$el_return_reason_voluntary.show()
                } else if (selected_type === that.return_reason.involuntary) {
                    that.$el_return_reason_involuntary.show()
                }
            }
        });
    }

    Self.prototype.initReturnReasonAdvancedToggle = function () {
        var that = this;

        $.sa.$document.on('change', that.select_toggle_return_reason_advanced, function (e) {
            var $toggle_select = $(e.target)

            if ($toggle_select.hasClass(that.select_toggle_return_reason_advanced.substring(1))) {
                var selected_type = $toggle_select.val()

                that.$el_return_reason_advanced_illness.hide()
    
                if (selected_type === that.return_reason_advanced.illness || selected_type === that.return_reason_advanced.death_family) {
                    that.$el_return_reason_advanced_illness.show()
                }
            }
        });
    }

    Self.prototype.initGroups = function () {
        var that = this;

        that.set_index_in_svc = function () {
            var $refund_svcs_blocks = that.$wrapper.find(that.select_refund_svcs)
            $refund_svcs_blocks.each(function (index) {
                var set_index = index + 1
                var $block = $(this)
                
                $block.find(that.select_refund_svcs_index).text(set_index === 1 ? '' : '№' + set_index)
                $block.find(that.select_refund_svcs_svc).attr('name', 'svc[' + set_index + '][svc]')
                $block.find(that.select_refund_svcs_emd).attr('name', 'svc[' + set_index + '][emd_number]')
            })
        }

        that.set_index_in_ticket = function () {
            var $refund_ticket_blocks = that.$wrapper.find(that.select_refund_ticket)
            $refund_ticket_blocks.each(function (index) {
                var set_index = index + 1
                var $block = $(this)

                $block.find(that.select_refund_ticket_index).text(set_index === 1 ? '' : '№' + set_index)
                $block.find(that.select_refund_ticket_number).attr('name', 'ticket[' + set_index + '][ticket_number]')
                $block.find(that.select_refund_ticket_fio).attr('name', 'ticket[' + set_index + '][fio]')
            })
        }

        that.initGroupBlocks(
            that.select_refund_svcs,
            that.select_refund_svcs_add_button,
            that.select_refund_svcs_remove_button,
            that.$copied_refund_svcs_template,
            function () {
                UIInputMask.prototype.initTicketNumber(that.$wrapper)
                that.set_index_in_svc()
            }
        )
        that.initGroupBlocks(
            that.select_refund_ticket,
            that.select_refund_ticket_add_button,
            that.select_refund_ticket_remove_button,
            that.$copied_refund_ticket_template,
            function () {
                UIInputMask.prototype.initTicketNumber(that.$wrapper)
                that.set_index_in_ticket()
            }
        )
    }

    return Self;
})(jQuery);